import { restDelete, restGet, restPost, restPut } from "apiCommandsExecutor/rest";

import { DeleteMenuItemBadgeResultDto, MenuItemBadgeDto } from "./restModels";
import { MenuItemBadgeRequestDto } from "./restRequests";

// ===== Бейджи позиций (REST /api/rest/warehouse/v1) =====
// Заведение бэк берёт из аккаунта — organizationBranchId в запросах не передаём.
// Порядка у справочника нет: порядок бейджей на карточке задаёт список badgeIds позиции.

export const getMenuItemBadges = () => restGet<MenuItemBadgeDto[]>("/menu-item-badges");

export const createMenuItemBadge = (body: MenuItemBadgeRequestDto) =>
    restPost<MenuItemBadgeDto>("/menu-item-badges", body);

export const updateMenuItemBadge = (menuItemBadgeId: number, body: MenuItemBadgeRequestDto) =>
    restPut<MenuItemBadgeDto>(`/menu-item-badges/${menuItemBadgeId}`, body);

// Удаление возвращает оставшийся реестр и число позиций, с которых бейдж сняли.
export const deleteMenuItemBadge = (menuItemBadgeId: number) =>
    restDelete<DeleteMenuItemBadgeResultDto>(`/menu-item-badges/${menuItemBadgeId}`);
